import { useId } from 'react'

export interface OpcionDeSelector {
  valor: string
  etiqueta: string
  descripcion?: string
}

export interface SelectorProps {
  etiqueta: string
  valor: string
  opciones: readonly OpcionDeSelector[]
  alCambiar: (valor: string) => void
  marcador?: string
  ayuda?: string
  requerido?: boolean
  compacto?: boolean
}

/** Selector nativo: accesible, operable con teclado, sin dependencias. */
export function Selector(props: SelectorProps) {
  const id = useId()
  const elegida = props.opciones.find((o) => o.valor === props.valor)
  const ayuda = elegida?.descripcion ?? props.ayuda
  return (
    <div className="grid gap-1">
      <label htmlFor={id} className="text-pequeno font-semibold text-texto">
        {props.etiqueta}
        {props.requerido ? <span aria-hidden="true"> *</span> : null}
      </label>
      <select
        id={id}
        value={props.valor}
        onChange={(e) => props.alCambiar(e.target.value)}
        aria-describedby={ayuda ? `${id}-ayuda` : undefined}
        className={`${props.compacto ? 'min-h-[36px]' : 'min-h-tactil'} w-full min-w-0 max-w-full rounded-md border border-borde bg-superficie px-3 text-cuerpo text-texto`}
      >
        {props.marcador ? <option value="">{props.marcador}</option> : null}
        {props.opciones.map((o) => (
          <option key={o.valor} value={o.valor}>
            {o.etiqueta}
          </option>
        ))}
      </select>
      {ayuda ? <p id={`${id}-ayuda`} className="text-pequeno text-texto-secundario">{ayuda}</p> : null}
    </div>
  )
}
